export default __webpack_public_path__ + "static/media/Icon-Bibliothek.c6d31ab0.svg";